import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'flx-line-item-display',
	templateUrl: './line-item-display.component.html',
	styleUrls: ['./line-item-display.component.scss']
})
export class LineItemDisplayComponent {
	@Input() lineItemFormGroup: FormGroup<any>;
	@Input() icons: { src: string; alt: string }[] = [];

	constructor() {}
}
